import { Button } from "@/components/ui/button";
import { ArrowLeft, Search } from "lucide-react";

interface LostFoundHeaderProps {
  onBack: () => void;
  username: string | undefined;
  onLogout: () => void;
}

const LostFoundHeader = ({ onBack, username, onLogout }: LostFoundHeaderProps) => (
  <header className="bg-white border-b p-4">
    <div className="container mx-auto flex justify-between items-center">
      <div className="flex items-center">
        <Button variant="ghost" size="sm" onClick={onBack} className="mr-2">
          <ArrowLeft size={16} />
        </Button>
        <div className="flex items-center space-x-2">
          <Search className="h-5 w-5 text-primary" />
          <h1 className="text-xl font-bold hidden sm:block">Lost and Found</h1>
        </div>
      </div>
      <div className="flex items-center space-x-4">
        <span className="text-sm text-muted-foreground">
          Logged in as: {username}
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={onLogout}
        >
          Logout
        </Button>
      </div>
    </div>
  </header>
);

export default LostFoundHeader;
